import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  periodos:[],
};
export const mutations = {
    FILL_PERIODOS({ context }, periodos) {
        let lista_periodos = [];
        if (periodos) {
          Object.entries(periodos).forEach(([key, val]) => lista_periodos.push(val));
          return (state.periodos = lista_periodos);
        }
    }
};
export const actions = {
    GET_PERIODOS({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.get(data)
            .then(response => {
              commit("SET_LOADING", false);
              commit("FILL_PERIODOS", response.data.data.periodos);
              resolve(response);
            })
            .catch(error => {
              commit("SET_LOADING", false);
              reject(error);
            });
        });
      },
};

export const getters = {
  listPeriodos: state => state.periodos,
  listPeriodos_Activo_y_Pasados( state ) {
    var peridosValidosInformes=[];
    state.periodos.forEach(element => {

      if (element.activo != 3){
        peridosValidosInformes.push(element)
      }
    });

    return peridosValidosInformes

  }
};
